import image from './Image.tsx';
import video from './Video.tsx';
import defaultRenderer from './Default.tsx';
import autoplayContent from './AutoPlayContent.tsx';

export const renderers = [image, video, autoplayContent, defaultRenderer];
